import { Box, Paper, Stack, Typography, Button, IconButton } from "@mui/material";
import React from "react";
import TAbletIcon from "../../shared/icon/tablet";
import LaptopIcon from "../../shared/icon/laptop-icon";
import MobileIcon from "../../shared/icon/mobile";
import { useSelector } from "react-redux";
import { RootStateType } from "../../redux/features/rootSlice";
import { getCalendarTime } from "../../shared/util/dateformatter";
import Signout from "../security/signout";
import DeleteIcon from "../../shared/icon/delete-icon";
import SessionSignout from "../security/session_signout";
import { clientsType } from "../../config/app";

const DevicesLogedinList = () => {
  let user = useSelector((state: RootStateType) => state.userStateReducer.user);
  let { loginDevice } = useSelector(
    (state: RootStateType) => state.authStateReducer
  );
  const clientType = useSelector((state: RootStateType) => state.deviceConfigReducer.clientType);
  const [signoutDialog, setSignoutDialog] = React.useState(false);
  const [sessionSignoutDialog, setSessionSignoutDialog] = React.useState(false);
  const [selectedSessionData, setSelectedSessionData] = React.useState({   ssosessionid : "",
    userid : "",
    sessionid : "",
    createdate : "",
    expirationdate : "",
    uabrowser : "",
    uabrowserversion : "",
    uaos : "",
    uaosversion : "",
    uadevicetype : "",
    ipaddress : "",
    location : "",
    isCurrent : false});

  const dialogClose = () => {
    setSignoutDialog(false);
  };
  const sessionSignoutdialogClose = () => {
    setSessionSignoutDialog(false);
  };
  return (
    <>
      <Paper elevation={0} sx={{ p: 3 }}>
        <Stack direction={"row"} justifyContent={"space-between"}>
          <Typography variant="h6" color="initial" fontSize={'0.8rem'}>
            Devices logged in
          </Typography>
          {/* conditinally showing sign out from all devices feature */}
          {clientType && clientType === clientsType.device ? null
            :
            <Button
              variant="text"
              color="primary"
              sx={{ ":hover": { background: "transparent" }, p: 0, fontSize: '0.8rem' }}
              onClick={() => setSignoutDialog(true)}
            >
              Sign out from all devices
            </Button>
          }
        </Stack>
        <Typography variant="body2" color="initial" mb={3}>
          Access your device settings to personalize your experience and manage
          configurations
        </Typography>

        <Stack gap={2}>
          <Stack direction={"row"} gap={2}>
            <Typography variant="body2" color="#909090" flex={'1.3 1 0%'}>
              Browsers
            </Typography>
            <Typography variant="body2" color="#909090" flex={'1 1 0%'}>
              Location
            </Typography>
            <Typography variant="body2" color="#909090" flex={'1 1 0%'}>
              Signed in
            </Typography>
            <Typography variant="body2" color="#909090" flex={'1 1 0%'}>
              IP address
            </Typography>
            <Typography variant="body2" color="#909090"sx={{minWidth: 100}}>
              
            </Typography>            

          </Stack>
          {loginDevice &&
            loginDevice?.map((item: any) => (
              <Stack key={item.ssosessionid} direction={"row"}>
                <Typography variant="caption"  color="initial" flex={'1.3 1 0%'} display={'flex'} alignItems={'center'}>
                  {/* <ChromeIcon />{" "} */}
                  {
                    item.uadevicetype === 'mobile' ? (
                      <MobileIcon />
                    ) : item.uadevicetype === 'tablet' ? (
                      <TAbletIcon />
                    ) : (
                      <LaptopIcon />
                    )
                  }{" "}
                  <Box pl={1} component={"span"}>
                    {item?.uabrowser} {item?.uaos ? `on ${item?.uaos}` : ""}
                  </Box>
                </Typography>
                <Typography variant="caption" color="initial" flex={'1 1 0%'}>
                  {item?.location}
                </Typography>
                <Typography variant="caption" color="initial" flex={'1 1 0%'}>
                  {getCalendarTime(item?.createdate)}
                </Typography>
                <Typography variant="caption" color="initial" flex={'1 1 0%'}>
                  {item?.ipaddress}
                </Typography>
                <Typography variant="caption" color="initial" sx={{minWidth: 100, textAlign: 'right'}}>
                {!item?.isCurrent?    <IconButton
                    color="primary"
                    sx={{ p: 0}}
                    onClick={() => {setSessionSignoutDialog(true); setSelectedSessionData(item)}}
                  >
                    <DeleteIcon width={16} height={16} />
                  </IconButton> : <Typography variant="caption" color="green">
                  Current session
                  </Typography>}
               
                </Typography>
              </Stack>
            ))}
        </Stack>

        <Box
          display={"grid"}
          alignItems={"center"}
          gridTemplateColumns={"200px 1fr 42px"}
          sx={{ borderBottom: "1px solid #eee", py: 1 }}
        ></Box>
      </Paper>
      <Signout
        open={signoutDialog}
        onClose={dialogClose}
      />
      <SessionSignout
        open={sessionSignoutDialog}
        onClose={sessionSignoutdialogClose}
        selectedSessionData={selectedSessionData}
      />
    </>
  );
};

export default DevicesLogedinList;
